import React from 'react';
import { motion } from 'framer-motion';

export const fadeUp = {
  hidden: { opacity: 0, y: 28 },
  show: (i = 0) => ({ opacity: 1, y: 0, transition: { duration: 0.6, delay: i * 0.08, ease: [0.2, 0.8, 0.2, 1] } }),
};

export const Reveal = ({ children, className = '', delay = 0, as = 'div' }) => {
  const Tag = motion[as] || motion.div;
  return (
    <Tag
      className={className}
      variants={fadeUp}
      custom={delay}
      initial="hidden"
      whileInView="show"
      viewport={{ once: true, margin: '-80px' }}
    >
      {children}
    </Tag>
  );
};

export const SectionHeader = ({ label, title, lead, align = 'left', children }) => (
  <Reveal className={`flex flex-col ${align === 'center' ? 'items-center text-center' : ''}`}>
    <span className="nl-label">{label}</span>
    <h2 className="nl-h2">{title}</h2>
    {lead && <p className="nl-lead">{lead}</p>}
    {children}
  </Reveal>
);

export const slugify = (s) => s.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/(^-|-$)/g, '');
